import React from "react";
import { PhaseHeader as StyledPhaseHeader, PhaseTitle, PhasePill, EventActions, SmallGhostBtn } from "./TraceabilityStyles";

const PhaseHeader = ({ icon, title, hint, eventCount, onExpand, onCollapse }) => {
  return (
    <StyledPhaseHeader>
      <PhaseTitle>
        <span style={{ fontSize: 16 }}>{icon}</span>
        {title}
        <span style={{ fontSize: 12, opacity: 0.7, fontWeight: 700 }}>
          {hint}
        </span>
      </PhaseTitle>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <PhasePill>{eventCount} events</PhasePill>
        <EventActions>
          <SmallGhostBtn onClick={onExpand}>Expand</SmallGhostBtn>
          <SmallGhostBtn onClick={onCollapse}>Collapse</SmallGhostBtn>
        </EventActions>
      </div>
    </StyledPhaseHeader>
  );
};

export default PhaseHeader;
